import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Optimized config for smooth performance
ScrollTrigger.config({
  ignoreMobileResize: true,
});

export { gsap, ScrollTrigger };
